export function formatAmount(str: string): string {
    const num = Number(str);
    if (isNaN(num)) return str;
    return num.toLocaleString("en-US");
}

export function formatDate(dateStr: string): string {
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    const day = dateStr.slice(6, 8);

    return `${year}-${month}-${day}`;
}

export function formatTime(str: string): string {
    const hh = str.slice(0, 2);
    const mm = str.slice(2, 4);
    const ss = str.slice(4, 6);

    return `${hh}:${mm}:${ss}`;
}

export function formatMinutesToKorean(minutes: number): string {  
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
  
    if (hours > 0 && remainingMinutes > 0) {
      return `${hours}시간 ${remainingMinutes}분`;
    } else if (hours > 0) {
      return `${hours}시간`;
    } else {
      return `${remainingMinutes}분`;
    }
  }

  export function addCommaAfterNumber(text: string): string {
    return text.replace(/(.)/g, "$1, ");
  }

  export function formatDateTimeToKorean(dateStr: string, timeStr: string): string {
    // Parse date string "2025-09-29"
    const [year, month, day] = dateStr.split('-').map(num => parseInt(num, 10));
    
    // Parse time string "22:43:04"
    const [hour, minute, second] = timeStr.split(':').map(num => parseInt(num, 10));
    
    return `${year}년 ${month}월 ${day}일 ${hour}시 ${minute}분 ${second}초`;
  }